module.exports = __webpack_public_path__ + "img/works-05_gas-calendar.8937ef12.png";